import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import Modal from "react-modal";
import ReactGA from 'react-ga';

// 1. Inject GTM Script into <head>
const gtmScript = document.createElement("script");
gtmScript.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-TCSZ5QPW');`;
document.head.appendChild(gtmScript);

// 2. Inject GTM NoScript into <body>
const noscript = document.createElement("noscript");
noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-TCSZ5QPW"
height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
document.body.prepend(noscript); // Prepend to ensure it's at the start of body

// 3. Inject JSON-LD Schema Markups
const schemas = [
  {
    "@context": "https://schema.org/",
    "@type": "Person",
    "name": "CA Vijender Aggarwal",
    "url": "https://cavijenderaggarwal.com/",
    "image": "https://aurumfiles.b-cdn.net/vasir.png",
    "sameAs": [
      "https://www.facebook.com/vagarwal123",
      "https://x.com/cavijendersir",
      "https://www.instagram.com/cavijenderaggarwal/?hl=en",
      "https://www.linkedin.com/in/ca-vijender-aggarwal-01836733a/",
      "https://in.pinterest.com/cavijenderaggarwal/",
      "https://cavijenderaggarwal.com/"
    ],
    "jobTitle": "CA Vijender Aggarwal: India’s Trusted Faculty for CA/CMA Taxation (Inter & Final)",
    "worksFor": { "@type": "Organization", "name": "CA Vijender Aggarwal Classes" }
  },
  {
    "@context": "https://schema.org",
    "@type": "CollegeOrUniversity",
    "name": "CA Vijender Aggarwal Classes",
    "alternateName": "CA Vijender Aggarwal",
    "url": "https://cavijenderaggarwal.com/",
    "logo": "https://pushsales.b-cdn.net/VAC%20Logo.png",
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "08920334084",
      "contactType": "customer service",
      "areaServed": "IN",
      "availableLanguage": ["en", "Hindi"]
    },
    "sameAs": [
      "https://www.instagram.com/cavijenderaggarwal/?hl=en",
      "https://www.facebook.com/vagarwal123",
      "https://www.linkedin.com/in/ca-vijender-aggarwal-01836733a/",
      "https://x.com/cavijendersir"
    ]
  },
  {
    "@context": "https://schema.org/",
    "@type": "WebSite",
    "name": "CA Vijender Aggarwal",
    "url": "https://cavijenderaggarwal.com/",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "{search_term_string}",
      "query-input": "required name=search_term_string"
    }
  }
];

schemas.forEach(schema => {
  const script = document.createElement("script");
  script.type = "application/ld+json";
  script.innerHTML = JSON.stringify(schema);
  document.head.appendChild(script);
});

Modal.setAppElement("#root");

ReactDOM.render(
  <App />,
  document.getElementById("root")
);


// import React from "react";
// import ReactDOM from "react-dom";
// import App from "./App";
// import Modal from "react-modal";
// import ReactGA from 'react-ga';


// Modal.setAppElement("#root");

// ReactDOM.render(
//   <App />,
//   document.getElementById("root")
// );

